export const TURNSTILE_CONTAINER_ID = "turnstile-container"

const TurnstileContainer = () => {
  return (
    <div id={TURNSTILE_CONTAINER_ID} class={"hidden"} />
  )
}

export default TurnstileContainer